module.exports = __webpack_public_path__ + "static/media/girl-down.fcf6fc49.png";